import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button, Typography, Alert } from 'antd';
import { LoginCredentials } from '../../models/LoginCredentials';
import { AppDispatch, RootState } from '../../redux/store';
import { login } from '../../redux/slices/authSlice';
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

export function Login() {
  const dispatch = useDispatch<AppDispatch>();
  const { loading, error } = useSelector((state: RootState) => state.auth);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const onFinish = async (values: LoginCredentials) => {
    try {
      const resultAction = await dispatch(login(values));
      if (login.fulfilled.match(resultAction)) {
        const user = resultAction.payload;
        if (user.isAdmin) {
          navigate('/resellers');
        } else if (user.isEsimReseller) {
          navigate('/');
        } else {
          navigate('/assign-sim-package');
        }
      }
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div style={{ maxWidth: 350, margin: '80px auto', padding: 24, background: '#fff', borderRadius: 8 }}>
      <Title level={3} style={{ textAlign: 'center' }}>POS Login</Title>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="username"
          label="Username"
          rules={[{ required: true, message: 'Please input your username!' }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input.Password />
        </Form.Item>

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Login
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
}

export default Login;
